// app/providers.tsx
'use client'

import {HeroUIProvider} from '@heroui/react'

export function NextProvider({children}) {
  return (
    <HeroUIProvider>
      {children}
    </HeroUIProvider>
  )
}